import { RefObject } from "react";
import { Download, Loader2 } from "lucide-react";
import { format } from "date-fns";
import { Button } from "@/components/ui/button";

interface RankTrackerReportProps {
  isPreview?: boolean;
  onExport?: () => void;
  isExporting?: boolean;
  reportRef?: RefObject<HTMLDivElement>;
}

export function RankTrackerReport({ isPreview = false, onExport, isExporting = false, reportRef }: RankTrackerReportProps) {
  const reportDate = format(new Date(), "MMMM d, yyyy");

  return (
    <>
      {!isPreview && onExport && (
        <div className="max-w-5xl mx-auto px-8 pt-8 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">Keyword Rank Performance Report</h1>
            <p className="text-muted-foreground mt-1">Generated on {reportDate}</p>
          </div>
          <Button onClick={onExport} disabled={isExporting} className="gap-2">
            {isExporting ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Download className="h-4 w-4" />
            )}
            {isExporting ? "Exporting..." : "Export to PDF"}
          </Button>
        </div>
      )}
      <div ref={reportRef} className="bg-background text-foreground min-h-screen p-8">
        <div className="max-w-5xl mx-auto space-y-8">
          <div className="border-b pb-6">
            <h1 className="text-3xl font-semibold text-foreground">Keyword Rank Performance Report</h1>
            <p className="text-muted-foreground mt-1">Generated on {reportDate}</p>
          </div>
          <div className="flex items-center justify-center py-24 text-muted-foreground text-sm">
            Report generation is not yet available.
          </div>
        </div>
      </div>
    </>
  );
}
